import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getDevice, type DeviceDetail as Detail } from '../api';

function fmtMin(m: number): string {
  const h = Math.floor(m / 60);
  const min = m % 60;
  return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
}

export default function DeviceDetail() {
  const { name = '' } = useParams();
  const [d, setD] = useState<Detail | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function load() {
    try {
      setErr(null);
      setD(await getDevice(name));
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  if (err) return <div className="error">{err}</div>;
  if (!d) return <p className="muted">読み込み中…</p>;

  return (
    <div>
      <div className="row" style={{ marginBottom: 12 }}>
        <Link to="/devices">← 端末一覧</Link>
      </div>
      <h2>{d.device.name}</h2>
      <p className="muted">
        prefix: {d.device.prefix} / created {d.device.createdAt} / lastSeen{' '}
        {d.device.lastSeenAt}
      </p>

      <div className="card">
        <h3>今日のシフト {d.shift ? `(${d.shift.date})` : ''}</h3>
        {d.shift ? (
          <>
            <p className="muted">
              マスク枠: {d.shift.maskedSlots.length} / 24
            </p>
            <div className="slots">
              {d.shift.slots.map((s) => (
                <div key={s.index} className={`slot ${s.masked ? 'masked' : ''}`}>
                  <div className="idx">
                    #{s.index} {fmtMin(s.startMinutes)}–
                    {fmtMin(s.endMinutes)}
                  </div>
                  <div className="pkg">{s.appPackage || '—'}</div>
                  {s.masked && (
                    <span className="badge warn">マスク</span>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="muted">未生成</p>
        )}
      </div>

      <div className="card">
        <h3>インベントリ</h3>
        {d.inventory ? (
          <>
            <p className="muted">
              {d.inventory.apps.length} 個 / postedAt {d.inventory.postedAt}
            </p>
            <ul style={{ fontFamily: 'monospace', fontSize: '0.85em' }}>
              {d.inventory.apps.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </>
        ) : (
          <p className="muted">未POST</p>
        )}
      </div>

      <div className="card">
        <h3>直近1時間の視聴（{d.recentViews.length}件）</h3>
        <table>
          <thead>
            <tr>
              <th>時刻</th>
              <th>ネットワーク</th>
              <th>Ad Unit</th>
              <th>アプリ</th>
            </tr>
          </thead>
          <tbody>
            {d.recentViews.map((v, i) => (
              <tr key={i}>
                <td className="muted">{v.ts}</td>
                <td>{v.network}</td>
                <td>{v.adUnitId}</td>
                <td style={{ fontFamily: 'monospace', fontSize: '0.9em' }}>
                  {v.appPackage}
                </td>
              </tr>
            ))}
            {d.recentViews.length === 0 && (
              <tr>
                <td colSpan={4} className="muted">
                  1時間以内の視聴はありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
